import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { useEffect } from "react";
import { Spinner } from "grommet";

const AuthenticatedUserRoute = () => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation(); // Get the current URL path

  if (isLoading) {
    return <Spinner />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  const { isBroadcaster } = user;
  if (isBroadcaster) {
    return <Navigate to="/" replace state={{ from: location }} />; // Redirect non-broadcasters to home or another page
  }

  return <Outlet />;
};

export default AuthenticatedUserRoute;
